/* global */
'use strict';

import * as _request from './consts-headers-request.js';
import * as _response from './consts-headers-response.js';

/**
 * @typedef {Object} CONSTSHEADERS
 */

/**
 * @type {CONSTSHEADERSREQUEST}
 */
export const request = _request;

/**
 * @type {CONSTSHEADERSRESPONSE}
 */
export const response = _response;

